import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface Props {
  /** Use 'header' when placed on a coloured/dark header bar (white text, translucent bg).
   *  Use 'page' when placed on the page background (uses theme token colours). */
  variant?: 'header' | 'page';
}

export const ThemeToggle: React.FC<Props> = ({ variant = 'header' }) => {
  const { theme, setTheme, tokens } = useTheme();
  const isDark = theme === 'dark';

  const headerStyle: React.CSSProperties = {
    background: 'rgba(255, 255, 255, 0.15)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    color: 'white',
  };

  const pageStyle: React.CSSProperties = {
    background: tokens.colors.cardBackground,
    border: `1px solid ${tokens.colors.border}`,
    color: tokens.colors.textPrimary,
  };

  const variantStyle = variant === 'header' ? headerStyle : pageStyle;

  const hoverBg = variant === 'header'
    ? 'rgba(255, 255, 255, 0.25)'
    : (isDark ? '#30363d' : '#f0f2f5');

  const restBg = variant === 'header'
    ? 'rgba(255, 255, 255, 0.15)'
    : tokens.colors.cardBackground;

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      style={{
        ...variantStyle,
        borderRadius: '6px',
        padding: '6px 12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '14px',
        fontWeight: 500,
        transition: 'all 0.2s',
      }}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      onMouseEnter={(e) => { e.currentTarget.style.background = hoverBg; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = restBg; }}
    >
      {isDark ? (
        <>
          <span style={{ fontSize: '16px' }}>☀️</span>
          <span>Light</span>
        </>
      ) : (
        <>
          <span style={{ fontSize: '16px' }}>🌙</span>
          <span>Dark</span>
        </>
      )}
    </button>
  );
};
